<template>
  <b-card title="Version" body-class="version-card">
    <table class="table">
      <tr>
        <td>
          <strong>Software version</strong>
        </td>
        <td class=" text-right" >
          {{software_version}}
        </td>
      </tr>
      <tr>
        <td>
          <strong>Platform version</strong>
        </td>
        <td class="text-right" >
          {{platform_version}}
        </td>
      </tr>
      <tr>
        <td>
          <strong>FPGA firmware version</strong>
        </td>
        <td class="text-right" >
          {{fpga_firmware_version}}
        </td>
      </tr>
      <tr>
        <td>
          <strong>Modem firmware version</strong>
        </td>
        <td class="text-right" >
          {{modem_firmware_version}}
        </td>
      </tr>
      <tr>
        <td>
          <strong>Wireless version</strong>
        </td>
        <td class="text-right" >
          {{wireless_version}}
        </td>
      </tr>
    </table>
    <CardTimestampFooter v-bind:timestamp="timestamp"/>
  </b-card>
</template>
<script>
import CardTimestampFooter from '@/components/Device/CardTimestampFooter/CardTimestampFooter';

export default {
  name: 'VersionCard',
  components: {CardTimestampFooter},
  props: ['version'],
  computed: {
    software_version(){
      return this._props.version ? this._props.version.software_version : 'UNKNOWN';
    },
    platform_version(){
      return this._props.version ? this._props.version.platform_version : 'UNKNOWN';
    },
    fpga_firmware_version(){
      return this._props.version ? this._props.version.fpga_firmware_version : 'UNKNOWN';
    },
    modem_firmware_version(){
      return this._props.version ? this._props.version.modem_firmware_version : 'UNKNOWN';
    },
    wireless_version(){
      return this._props.version ? this._props.version.wireless_version : 'UNKNOWN';
    },
    timestamp(){
      return this._props.version && this._props.version.timestamp ? this._props.version.timestamp : null;
    }
  }
}
</script>

<style src="./VersionCard.scss" lang="scss" scoped/>
